// extracted by mini-css-extract-plugin
module.exports = {"container":"c6OfoP3","slider":"BN_AUU"};